/**
 * @fileoverview Application constants
 */
export const APP_NAME = 'AeroCert';
export const APP_DESCRIPTION = 'Plataforma de certificación aérea';
export const MENU_ITEMS = [
    {
        id: 'home',
        label: 'Inicio',
        icon: 'fas fa-home',
        path: '/home',
    },
    {
        id: 'courses',
        label: 'Cursos',
        icon: 'fas fa-graduation-cap',
        path: '/courses',
    },
    {
        id: 'maintenance',
        label: 'Mantenimiento',
        icon: 'fas fa-wrench',
        path: '/maintenance',
    },
    {
        id: 'history',
        label: 'Historial',
        icon: 'fas fa-history',
        path: '/history',
    },
    {
        id: 'students',
        label: 'Alumnos / Clientes',
        icon: 'fas fa-users',
        path: '/students',
    },
    {
        id: 'settings',
        label: 'Configuración',
        icon: 'fas fa-cog',
        path: '/settings',
    },
];
export const CERTIFICATE_TYPES = [
    { value: 'Piloto Privado (PPL)', label: 'Piloto Privado (PPL)' },
    {
        value: 'Habilitación Vuelo Instrumental',
        label: 'Habilitación Vuelo Instrumental',
    },
    { value: 'Piloto Comercial (CPL)', label: 'Piloto Comercial (CPL)' },
    { value: 'Instructor de Vuelo (CFI)', label: 'Instructor de Vuelo (CFI)' },
    { value: 'Piloto de Transporte de Línea Aérea (ATPL)', label: 'Piloto de Transporte de Línea Aérea (ATPL)' },
    { value: 'Entrenamiento en Simulador', label: 'Entrenamiento en Simulador' },
    { value: 'Curso de Seguridad de Vuelo', label: 'Curso de Seguridad de Vuelo' },
    { value: 'Entrenamiento de Emergencias', label: 'Entrenamiento de Emergencias' },
    { value: 'Habilitación Multi-Motor', label: 'Habilitación Multi-Motor' },
    { value: 'Habilitación de Hidroavión', label: 'Habilitación de Hidroavión' },
];
export const MAINTENANCE_TYPES = [
    { value: 'Inspección 100 Horas', label: 'Inspección 100 Horas' },
    { value: 'Inspección Anual', label: 'Inspección Anual' },
    { value: 'Inspección Pre-Vuelo', label: 'Inspección Pre-Vuelo' },
    { value: 'Mantenimiento Mayor', label: 'Mantenimiento Mayor' },
    { value: 'Reparación Estructural', label: 'Reparación Estructural' },
    { value: 'Overhaul Motor', label: 'Overhaul Motor' },
    { value: 'Revisión de Sistemas', label: 'Revisión de Sistemas' },
];
export const CERTIFICATE_MODES = {
    pilot: {
        label: 'Cursos',
        organization: 'ACADEMIA VUELO SUR',
        namePlaceholder: 'Ej. Juan Pérez',
        idPlaceholder: 'Ej. AR-123456',
    },
    mro: {
        label: 'Mantenimiento',
        organization: 'AERO TALLER CENTRAL',
        namePlaceholder: 'Modelo Avión (ej. Cessna 172)',
        idPlaceholder: 'Matrícula (ej. LV-GHT)',
    },
};
